









import VueOptions from '@utils/VueOptions'
import LoadingIndicator from '@/components/LoadingIndicator'
import EventDetail from '@ui/Event/EventDetail'
import EventPricingBox from '@ui/Campaign/pipeline/Event/EventPricingBox'
import EventInstances from '@ui/Event/EventInstances'

settings =
  name: 'EventShow'
  components: { LoadingIndicator, EventDetail, EventPricingBox, EventInstances }

  resources:
    event:
      resourceName: 'event'
      slug: 'events/:eventId'

    audience_partnership:
      resourceName: 'audience_partnership'
      slug: 'audience_partnerships/:buy_partnership'
      fetch: false

    nearbyPOIs:
      resourceName: 'nearby_poi'
      slug: 'nearby_pois/:eventId'
      fetch: false

  vue:
    mounted: ->
      @fetch 'audience_partnership' if @buyPartnershipToken?.length

    computed:
      isLoading: -> !@event
      buyPartnershipToken: -> @$route.query.buy_partnership

      pricingTable: -> @audience_partnership?.pricing_table || @event.pricing_table || {}

      bookedSamplingPrice: ->
        data = @partnerBuy()
        data.bookings ||= {}

        eventSetId = @event.event_set_id
        price = null

        spaces = data.bookings?[eventSetId]?.spaces || []

        for spaceName, space of spaces
          continue if space.type isnt 'product_sampling' || 0 is space.pricing_model?.length
          pricing = @pricingTable[space.pricing_model]
          continue unless pricing
          price = parseFloat(pricing.price_in_cents || 0) / 100

        price

      earliestListing: -> @audience_partnership?.earliest_listing || 1

      eventInstances: ->
        @ctxEventInstances(@event).filter((e) => dayjs(e.local_start_day).isAfter(dayjs().add(@earliestListing, 'day')))

      selectedEventInstanceIds: ->
        data = @partnerBuy()
        data.bookings ||= {}
        ids = []
        ids = [...ids, ...booking.event_ids] for eventSetId, booking of data.bookings
        ids

      actionsForEventDetails: ->
        addBookingSpace: @addBookingSpaceToSession
        removeBookingSpace: @removeBookingSpaceFromSession
        spaceIsBooked: @spaceIsBooked

      actionsForEventPricingBox: ->
        add: @selectEventInstanceToSession
        spaceIsBooked: @spaceIsBooked
        addBookingSpace: @addBookingSpaceToSession
        removeBookingSpace: @removeBookingSpaceFromSession

      actionsForEventInstances: ->
        select: @selectInstance
        unselect: @unSelectInstance
        navigateToInstance: @navigateToInstance

      eventDetailOptions: ->
        showSamplingPricing: !!@audience_partnership?.show_pricing
        bookedSamplingPrice: @bookedSamplingPrice
        pricingTable: @pricingTable

    methods:
      hiNavigateToCampaignWizard: -> @$router.push({ name: 'CampaignCreatePage' })

      partnerBuy: -> { ...@getAppSession('partnerBuy', {}) }

      selectInstance: (ev) ->
        @selectEventInstanceToSession ev
        @navigateToInstance ev

      unSelectInstance: (ev) ->
        @removeEventInstanceFromSession ev

      selectEventInstanceToSession: (ev, space) ->
        data = @partnerBuy()
        data.bookings ||= {}
        eventSetId = ev.event_set_id

        data.bookings[eventSetId] ||= {}
        data.bookings[eventSetId].event_ids ||= []
        return if data.bookings[eventSetId].event_ids.includes ev.id

        data.bookings[eventSetId].event_ids.push ev.id
        data.config = @bookingConfigForEvent ev
        @setAppSession 'partnerBuy', data

      removeEventInstanceFromSession: (ev) ->
        data = @partnerBuy()
        data.bookings ||= {}

        eventSetId = ev.event_set_id
        return unless data.bookings[eventSetId]

        data.bookings[eventSetId].event_ids ||= []
        data.bookings[eventSetId].event_ids = data.bookings[eventSetId].event_ids.filter((id) -> id isnt ev.id)

        isEmptySpaces = 0 is Object.values(data.bookings[eventSetId]?.spaces || {}).length
        isEmptyEventIds = 0 is data.bookings[eventSetId]?.event_ids?.length
        delete data.bookings[eventSetId] if isEmptySpaces and isEmptyEventIds

        @setAppSession 'partnerBuy', data

      bookingConfigForEvent: (ev) ->
        data = @partnerBuy()
        data.config ||= {}

        data.config =
          partner_pricing_table: @pricingTable
          spaces: @configureSpaces(ev, data.config.spaces)
          storage: @configureStorage(ev, data.config.storage)
          sampling_services: @configureSamplingServices(ev, data.config.sampling_services)

        data.config

      configureSpaces: (ev, configSpaces) ->
        configSpaces ||=
          types: []
          categories: {}

        for name, space of (ev.spaces || {})
          configSpaces.types.push space.type unless configSpaces.types.includes space.type
          configSpaces.categories[space.category] ||= {}
          configSpaces.categories[space.category].url ||= space.image

        configSpaces

      configureStorage: (ev, configStorage=[]) ->
        storageUnits = ['storage_available', 'climate_controlled_storage_available', 'cold_storage_available', 'frozen_storage_available', 'storage_out_of_sunlight_available']

        for unit in storageUnits
          continue if configStorage.includes unit
          configStorage.push unit if ev.restrictions?.onsite?[unit] is 'yes'

        configStorage

      configureSamplingServices: (ev, configSamplingServices={}) ->
        configSamplingServices.can_assemble_items ||= !!ev.spaces?['Product Sampling']?.can_assemble_items
        configSamplingServices.can_serve_cold ||= !!ev.spaces?['Product Sampling']?.can_serve_cold
        configSamplingServices

      addBookingSpaceToSession: (space, pricingModel, ev=@event) ->
        @selectEventInstanceToSession ev
        eventSetId = ev.event_set_id

        data = @partnerBuy()
        data.bookings ||= {}
        data.bookings[eventSetId].spaces ||= {}
        data.bookings[eventSetId].spaces[space.name] = { pricing_model: pricingModel, space_type: space.type, space_category: space.category }
        @setAppSession 'partnerBuy', data

      removeBookingSpaceFromSession: (spaceName, ev=@event) ->
        data = @partnerBuy()
        data.bookings ||= {}

        eventSetId = ev.event_set_id
        return unless data.bookings[eventSetId]
        delete data.bookings[eventSetId]?.spaces?[spaceName]

        isEmptySpaces = 0 is Object.values(data.bookings[eventSetId]?.spaces || {}).length
        isEmptyEventIds = 0 is data.bookings[eventSetId]?.event_ids?.length
        delete data.bookings[eventSetId] if isEmptySpaces and isEmptyEventIds

        @setAppSession 'partnerBuy', data

      spaceIsBooked: (space, pricingModel, ev=@event) ->
        data = @partnerBuy()

        eventSetId = ev.event_set_id
        s = data.bookings?[eventSetId]?.spaces?[space.name]

        return false if pricingModel and s?.pricing_model isnt pricingModel
        s?.space_type is space.type

      navigateToInstance: (event) ->
        { buy_partnership } = @$route.query
        @$router.push { name: 'EventShowPage', params: { eventId: event.id }, query: { buy_partnership } }
        @fetch 'event'

    watch:
      event: (ev) ->
        @selectEventInstanceToSession ev if ev

      audience_partnership: ->
        return unless @audience_partnership
        data = @partnerBuy()
        data.audience_partnership = {}
        data.audience_partnership.logo = @audience_partnership.logo
        data.audience_partnership.supplier = {}
        data.audience_partnership.supplier.name = @audience_partnership.supplier.name
        data.audience_partnership.supplier.logo = @audience_partnership.supplier.logo
        @setAppSession 'partnerBuy', data

export default VueOptions.vue settings
